import { message } from 'antd'
import { change } from 'redux-form'
import { sendRamsForApproval } from '../../../../../HttpRequests/ramsRecords'
import fetchRamsRecords from '../../../../../Screens/ProjectView/Services/fetchRamsRecords'
import { FORM_NAME } from '../../../Form'
import _props from '../../../props'

export default () => async (dispatch) => {

  const { ramsRecordId } = _props.get()

  if (!ramsRecordId) {
    message.warning('Please save the RAMS record first before sending for approval.')
    return
  }

  try {
    await sendRamsForApproval(ramsRecordId)
    dispatch(change(FORM_NAME, 'status', 'awaiting_approval'))
    dispatch(fetchRamsRecords())
    message.success('RAMS record sent for approval. H&S users have been notified.')
    _props.get().onClose()
  } catch (error) {
    const msg = error.response && error.response.data && error.response.data.error
      ? error.response.data.error
      : 'Failed to send for approval'
    message.error(msg)
  }

}
